import { fetchWrapper } from "../Helpers";

export const searchProfileService = {
  searchInfluencerProfile,
  getSocialAccounts,
  getBalance,
  getVisibleGalleryImage,
  getPieChartData,
  getProfiles,
  getIGInsights
};

function getVisibleGalleryImage(id) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/users/` + id + "/gallery-images/visible"
  );
}

function searchInfluencerProfile(profileid, usertype) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/user-data/` + profileid + "?type=" + usertype
  );
}
function getSocialAccounts(id, usertype) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/influencerSearchProfile/influencer-product/` +
      id +
      "/" +
      usertype
  );
}
function getBalance() {
  return fetchWrapper.get(`${process.env.REACT_APP_API_URL}/balance`);
}

function getPieChartData(id, userType) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/inf-analytics?user_id=${id}&type=${userType}`
  );
}

function getProfiles(userName) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/ig-insights/profiles/username/${userName}`
  );
}

function getIGInsights(id, userType) {
  return fetchWrapper.get(
    `${process.env.REACT_APP_API_URL}/ig-insights/profiles/ig-user-id/${id}?type=${userType}`
  );
}
